import { projectManagementApi } from '@/includes/projectManagementApi';

const pmConstraintService = {
  async listConstraints(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/constraints`);
    return response.data;
  },

  async getConstraint(projectId, id) {
    const response = await projectManagementApi.get(`/projects/${projectId}/constraints/${id}`);
    return response.data;
  },

  async createConstraint(projectId, payload) {
    const response = await projectManagementApi.post(
      `/projects/${projectId}/constraints`,
      payload,
    );
    return response.data;
  },

  async updateConstraint(projectId, id, payload) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/constraints/${id}`,
      payload,
    );
    return response.data;
  },

  async deleteConstraint(projectId, id) {
    const response = await projectManagementApi.delete(
      `/projects/${projectId}/constraints/${id}`,
    );
    return response.data;
  },

  async resolveConstraint(projectId, id) {
    const response = await projectManagementApi.patch(
      `/projects/${projectId}/constraints/${id}/status`,
      { status: 'resolved' },
    );
    return response.data;
  },

  async getConstraintsSummary(projectId) {
    const response = await projectManagementApi.get(
      `/projects/${projectId}/constraints/summary`,
    );
    return response.data;
  },
};

export default pmConstraintService;
